import { useQuery } from '@tanstack/react-query'
import { useShallow } from 'zustand/react/shallow'
import { useAuthStore } from '@/shared/store/auth-store'
import { authService } from '../service'

export const useMe = () => {
  const { isAuthenticated } = useAuthStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
    }))
  )

  return useQuery({
    ...authService.getMe,
    enabled: isAuthenticated,
  })
}
